import React, { useCallback, useEffect, useState } from "react";
import Products from "../products/Products";
import { Row, Col } from "react-bootstrap";
import { Circles } from "react-loader-spinner";
import Title from "../titles/Title";
import Slider from "react-slick";
import MainService from "../../common/MainService";

const CategoryProducts = ({ categoryId, title, description, btn1text, btn2text= "", subcategory, price }) => {
  const [categoryIdValue] = useState(categoryId);
  const [getProducts, setProducts] = useState([]);
  const [loding, setLoading] = useState(true);
  // const getProductsHandler = () => {
  //   MainService.getAllProductsofUser(window.livasaConfig.user, catId)
  //     .then((res) => {
  //       const filteredData = res.filter((e, i) => {
  //         return e.status === "Listed";
  //       });
  //       setProducts(filteredData);
  //       setLoading(false);
  //     })
  //     .catch((err) => {
  //       console.log("Error", err);
  //     });
  // };

  const getProductsHandler = useCallback(() => {
    const AllProducts = categoryIdValue.map((catId) => {
      
      // getAllProductsofUser changed to getProductOfUser
      return MainService.getAllProductsofUser(window.livasaConfig.user, catId)
        .then((res) => {
          if (!res || res.length === 0) {
            console.log(`No products found for category ID: ${catId}`);
            return []; // Return an empty array if no products are found
          }
          return res.filter((e) => e.status === "Listed"  && e.consumeradminid === (window.livasaConfig.user).toLowerCase());
        })
        .catch((err) => {
          if (err.response && err.response.status === 500) {
            console.error("Server error (500) occurred:", err);
          } else {
            console.log("Error during fetching all categories' products", err);
          }
          setLoading(false);
          return []; 
        });
    })
    

    Promise.all(AllProducts)
    .then((res) => {
      const combinedProducts = res.flat()
      setProducts(combinedProducts);
      setLoading(false);
    })
    .catch((err)=>{
      console.log("Error" , err)
    })
  },[categoryIdValue])


  

  useEffect(() => {
    getProductsHandler();
  }, [categoryId,getProductsHandler]);

  var settings = {
    infinite: true,
    speed: 2000,
    autoplay: true,
    autoplaySpeed: 2500,
    slidesToShow: 2,
    slidesToScroll: 2,
    initialSlide: 1,

    responsive: [
      {
        initialSlide: 1,
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,

          prevArrow: false,
          nextArrow: false,
          arrows: false,
        },
      },
    ],
  };
  return (
    <>
      <div className="section-container">
        <div className="container">
          <div className="section-sub-container text-center">
            <Title classname="mb-5" heading={title} />
          </div>
          <Row>
            {loding === false ? (
              <>
                {getProducts.length !== 0 ? (
                  <Slider {...settings}>
                    {getProducts.map((e, index) => {
                      return (
                        <Col
                        key={index}
                          md={12}
                          lg={6}
                          sm={12}
                          xs={12}
                          className="px-3 justify-self-center"
                        >
                          <Products
                            src={e.productimageurl}
                            src1={e.qacertificateurl}
                            produtName={e.productfriendlyname}
                            discount={e.discountedprice}
                            productPrice={e.productcost}
                            origin={e.country}
                            url={e.infourl}
                            count={e.itemcount}
                            qr={e.productqrcodeurl}
                            likes={e.likes}
                            certificate={e.qacertificateurl}
                            model_id={e.productid}
                            likecount={e.likecount}
                            product={e}
                            buylink={e.buyurl}
                            btn1text={btn1text}
                            btn2text={btn2text}
                            contentsubcategory={e.contentsubcategory}
                            subcategory= {subcategory}
                            price={price}
                          />
                        </Col>
                      );
                    })}
                  </Slider>
                ) : (
                  <h3 className="title">{description}</h3>
                )}
              </>
            ) : (
              <div className="justify-content-center d-flex">
                <Circles
                  type="TailSpin"
                  color="orange"
                  height={70}
                  width={70}
                  timeout={5000}
                />
              </div>
            )}
          </Row>
        </div>
      </div>
    </>
  );
};

export default CategoryProducts;
